import React from "react";
import Layout from "@/components/Layout";
import { BoxHeaderInner, StyledPageWrapperBox } from "@/components/styled";
import FinanceTable from "./components/FinanceTable";

const FinancePage = () => {
  return (
    <Layout>
      <StyledPageWrapperBox>
        <FinanceTable />
      </StyledPageWrapperBox>
      <BoxHeaderInner />
    </Layout>
  );
};

export default FinancePage;
